import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)

let _lang = 'zh'
const urlParams = new URLSearchParams(window.location.search);
const paramValueLang = urlParams.get('lang');
if(paramValueLang && (!localStorage.getItem('pro__isChangeLang') || !JSON.parse(localStorage.getItem('pro__isChangeLang')).value)){
  _lang = paramValueLang
  localStorage.setItem('pro__lang', JSON.stringify({value: paramValueLang, expire: null}))
} else if(localStorage.getItem('pro__lang')){
  _lang = JSON.parse(localStorage.getItem('pro__lang')).value
}

localStorage.setItem('pro__isChangeLang', JSON.stringify({value: false, expire: null}))

const i18n = new VueI18n({
    locale: _lang,
    messages
})

locale.i18n((key, value) => i18n.t(key, value))

export default i18n
